var map = {
	"./openapi.1.35.0.json": 71370,
	"./openapi.1.36.0.json": 35893,
	"./openapi.1.37.0.json": 18085,
	"./openapi.1.38.0.json": 60492,
	"./openapi.1.39.0.json": 73816,
	"./openapi.1.39.1.json": 41603,
	"./openapi.1.39.2.json": 58015,
	"./openapi.1.40.0.json": 89342
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20524;